import { FC } from "react";
import { Placement } from "tippy.js";

import { StyledTippy } from "./styles";

interface TooltipProps {
  content: React.ReactNode;
  referenceElement?: Element | null;
  placement?: Placement;
  maxWidth?: number | string;
}

export const Tooltip: FC<TooltipProps> = ({
  content,
  referenceElement,
  placement = "top-start",
  maxWidth = 150,
}) => {
  return (
    <StyledTippy
      reference={referenceElement}
      content={content}
      placement={placement}
      maxWidth={maxWidth}
    />
  );
};
